module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Liczba newsów na stronę",
      "required": "",
      "error": _vm.errors.page_size
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.page_size),
      callback: function($$v) {
        _vm.$set(_vm.form, "page_size", $$v)
      },
      expression: "form.page_size"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tagi",
      "error": _vm.errors['tags']
    }
  }, [_c('el-select', {
    staticClass: "fluid",
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "default-first-option": "",
      "placeholder": "Tagi"
    },
    model: {
      value: (_vm.form['tags']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'tags', $$v)
      },
      expression: "form['tags']"
    }
  }, _vm._l((_vm.tags), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a391251e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/NewsWidget.vue
// module id = 791
// module chunks = 0